// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"OptionalTooltip_tooltip__fPQTC"};